export default "__VITE_ASSET__C3vnDcRi__"